import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import { Plugin } from './plugin'

/**
 * @see {@link Plugin}, {@link ec.plugins.Plugin.Factory}
 */
export class Factory<TTypeParams extends ec.models.TypeParams.Constraint>
  implements
    ec.plugins.Plugin.Factory<
      TTypeParams,
      typeof Plugin.id,
      Plugin<TTypeParams>
    >
{
  /** @see {@link Plugin.id} */
  public readonly id = Plugin.id

  /** Creates a {@link Plugin} for the given {@link ec.Collection} */
  public produceFor(
    collection: ec.Collection<TTypeParams>,
  ): Plugin<TTypeParams> {
    return new Plugin({ collection })
  }
}
